// @flow

import { rest } from 'msw'

export const getGoogleAnalyticsMswHandler = rest.get('https://www.google-analytics.com/*', (req, res, ctx) => {
  return res(ctx.status(200))
})
